module.exports = __webpack_public_path__ + "bn.svg?f6d5f4005cca9ebb9883e5fb4e3edba9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bn.svg
// module id = 1264
// module chunks = 0